import { BORDER_WIDTH, CONTAINER_WIDTH, OPTIONS_GAP, PADDING_WIDTH } from '../../constants';

export const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '12px',
  },

  optionsWrapper: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },

  optionsContainer: {
    display: 'flex',
    border: `${BORDER_WIDTH}px solid #f1f3f9`,
    padding: `6px ${PADDING_WIDTH}px`,
    gap: `${OPTIONS_GAP}px`,
    width: `${CONTAINER_WIDTH}px`,
    maxWidth: `${CONTAINER_WIDTH}px`,
    borderRadius: '6px',
    overflowX: 'auto',
    position: 'relative',
    scrollbarWidth: 'none',
  },

  addNewOption: {
    '& button': {
      minWidth: '100%',
      marginTop: '18px',
      borderRadius: '12px',
    },
  },
};
